<template>
    <div class="row menu-panel">
        <div class="col">
            <!-- No product available -->
            <div v-if="products.length === 0" class="text-center mt-5">
                <img alt="" class="img-fluid" width="30%" src="https://cdn-icons-png.flaticon.com/512/776/776495.png"
                    onerror="this.onerror=null;this.src='https://www.img.in.th/images/d6fa08b8f195f3808f7f3bbcb8e43c9f.png';" />
                <p class="mt-3 font-weight-bold">{{ $t('noPreduct') }}</p>
            </div>
            <div v-else>
                <!-- ========== Grouped by Category (All Products tab) ========== -->
                <template v-if="isAllCategory && groupedProducts.length > 0">
                    <div v-for="(group, gIndex) in groupedProducts" :key="'group-' + gIndex"
                        :id="'category-section-' + group.categoryObjectId" class="category-section">
                        <div class="category-group-header">
                            <i v-if="group.indexIcon" :class="group.indexIcon" class="category-group-icon"></i>
                            <span class="category-group-name">{{ group.categoryName }}</span>
                        </div>
                        <div v-if="isSelfOrderEnabled === true" class="row p-2">
                            <!-- List mode -->
                            <div v-if="display === 'list'" class="col p-0">
                                <table class="mb-3" aria-describedby="" style="width: 100%">
                                    <tr v-for="(product, index) in group.products"
                                        :key="product.objectId + '-list-' + index"
                                        :style="{ 'border-bottom': '1px solid rgba(246, 246, 246)', opacity: isAllowToOrder(product) ? 1 : 0.5 }"
                                        @click="productDetailHandler(product)"
                                        :data-toggle="isAllowToShowDetailModal(product)" data-target="#detailModal">
                                        <td style="width: 25%; padding: 7px">
                                            <div v-if="!product.remoteImagePath" class="square-box shadow-menu"
                                                :style="{ 'background-color': getImgColor(product.indexColor), width: '100%' }">
                                                <span v-if="!isAllowToOrder(product)"
                                                    class="font-weight-bold add-to-cart-badges-nostock">
                                                    <h4 class="mt-2 text-center">{{ $t('outOfStock') }}</h4>
                                                </span>
                                            </div>
                                            <div v-else class="square-box shadow-menu" :style="{ width: '100%' }">
                                                <img v-lazy="getImageURL(product.remoteImagePath, '100')"
                                                    class="image-inbox">
                                                <span v-if="!isAllowToOrder(product)"
                                                    class="font-weight-bold add-to-cart-badges-nostock">
                                                    <h4 class="mt-2 text-center">{{ $t('outOfStock') }}</h4>
                                                </span>
                                            </div>
                                        </td>
                                        <td valign="top" class="p-2">
                                            <div class="d-flex justify-content-between">
                                                <div>
                                                    <div class="h5 autoShowHide" style="padding-top: 5px;">{{
                                                        getProductName(product) }}</div>
                                                    <div style="width: 60vw;">
                                                        <h6 class="text-grey limited-text-two">{{
                                                            product.description || "" }}</h6>
                                                    </div>
                                                    <h6 class="text-black">฿{{ product.ProductPRU[0]?.exceedUc || ''
                                                        }}</h6>
                                                </div>
                                                <div class="text-right d-flex align-items-center">
                                                    <div class="pt-3 text-center">
                                                        <span v-if="quantityShow(product.ProductPLU) > 0"
                                                            style="font-size: medium;border-radius: 50%;width: 25px;aspect-ratio: 1/1;"
                                                            class="bg-color-theme font-weight-bold badge">
                                                            {{ quantityShow(product.ProductPLU) }}
                                                        </span><br>
                                                    </div>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <!-- Grid mode -->
                            <template v-else-if="display === 'grid'">
                                <div class="col-6 pr-2 pl-2"
                                    v-for="(product, index) in group.products"
                                    :key="product.objectId + '-grid-' + index">
                                    <div @click="productDetailHandler(product)"
                                        :data-toggle="isAllowToShowDetailModal(product)" data-target="#detailModal">
                                        <div v-if="!product.remoteImagePath" class="square-box shadow-menu" :style="{
                                            'background-color': getImgColor(product.indexColor), width: '100%'
                                        }">
                                            <span v-if="getTotalQuantity(product.ProductPLU[0].id) == 0"
                                                class="font-weight-bold bg-color-theme badge add-to-cart-badges-noqty">+</span>
                                            <span v-else class="font-weight-bold badge add-to-cart-badges">
                                                {{ getTotalQuantity(product.ProductPLU[0].id) }}
                                            </span>
                                        </div>
                                        <div v-else
                                            v-lazy:background-image="getImageURL(product.remoteImagePath, '300')"
                                            class="square-box shadow-menu" :style="{
                                                width: '100%', 'background-size': 'cover', 'background-position': 'center center'
                                            }">
                                            <span
                                                v-if="getTotalQuantity(product.ProductPLU[0].id) == 0 && isAllowToOrder(product)"
                                                class="font-weight-bold bg-color-theme badge add-to-cart-badges-noqty">+</span>
                                            <span v-else-if="!isAllowToOrder(product)"
                                                class="font-weight-bold add-to-cart-badges-nostock">
                                                <h4 class="mt-2 text-center">{{ $t('outOfStock') }}</h4>
                                            </span>
                                            <span v-else class="font-weight-bold badge add-to-cart-badges">
                                                {{ getTotalQuantity(product.ProductPLU[0].id) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <div class="mt-2 h5 autoShowHide" style="padding-top: 5px;">{{
                                            getProductName(product) }}</div>
                                    </div>
                                    <div class="d-flex justify-content-between">
                                        <h6 class="text-grey pl-1 pb-3">฿{{ product.ProductPRU[0]?.exceedUc || ''
                                            }}</h6>
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                    <!-- Load More (grouped view) -->
                    <div v-if="currentPage < pageCount" class="text-center p-3">
                        <button class="btn btn-outline-secondary btn-sm load-more-btn" :disabled="loadingMore"
                            @click="loadMoreProducts()">
                            <span v-if="loadingMore">กำลังโหลด...</span>
                            <span v-else>โหลดเพิ่มเติม ({{ currentPage }}/{{ pageCount }})</span>
                        </button>
                    </div>
                </template>

                <!-- ========== Normal flat view (specific category selected) ========== -->
                <template v-else>
                    <div v-if="isSelfOrderEnabled === true" class="row p-2">
                        <div v-if="display === 'list'" class="col p-0">
                            <table class="mb-3" aria-describedby="" style="width: 100%">
                                <tr v-for="(product, index) in products"
                                    :key="product.objectId + '-list-' + index"
                                    :style="{ 'border-bottom': '1px solid rgba(246, 246, 246)', opacity: isAllowToOrder(product) ? 1 : 0.5 }"
                                    @click="productDetailHandler(product)"
                                    :data-toggle="isAllowToShowDetailModal(product)" data-target="#detailModal">
                                    <td style="width: 25%; padding: 7px">
                                        <div v-if="!product.remoteImagePath" class="square-box shadow-menu"
                                            :style="{ 'background-color': getImgColor(product.indexColor), width: '100%' }">
                                            <span v-if="!isAllowToOrder(product)"
                                                class="font-weight-bold add-to-cart-badges-nostock">
                                                <h4 class="mt-2 text-center">{{ $t('outOfStock') }}</h4>
                                            </span>
                                        </div>
                                        <div v-else class="square-box shadow-menu" :style="{ width: '100%' }">
                                            <img v-lazy="getImageURL(product.remoteImagePath, '100')"
                                                class="image-inbox">
                                            <span v-if="!isAllowToOrder(product)"
                                                class="font-weight-bold add-to-cart-badges-nostock">
                                                <h4 class="mt-2 text-center">{{ $t('outOfStock') }}</h4>
                                            </span>
                                        </div>
                                    </td>
                                    <td valign="top" class="p-2">
                                        <div class="d-flex justify-content-between">
                                            <div>
                                                <div class="h5 autoShowHide" style="padding-top: 5px;">{{
                                                    getProductName(product) }}</div>
                                                <div style="width: 60vw;">
                                                    <h6 class="text-grey limited-text-two">{{ product.description || ""
                                                        }}</h6>
                                                </div>
                                                <h6 class="text-black">฿{{ product.ProductPRU[0]?.exceedUc || '' }}
                                                </h6>
                                            </div>
                                            <div class="text-right d-flex align-items-center">
                                                <div class="pt-3 text-center">
                                                    <span v-if="quantityShow(product.ProductPLU) > 0"
                                                        style="font-size: medium;border-radius: 50%;width: 25px;aspect-ratio: 1/1;"
                                                        class="bg-color-theme font-weight-bold badge">
                                                        {{ quantityShow(product.ProductPLU) }}
                                                    </span><br>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <!-- Grid mode -->
                        <div class="col-6 pr-2 pl-2" v-else-if="display === 'grid'"
                            v-for="(product, index) in products" :key="product.objectId + '-grid-' + index">
                            <div @click="productDetailHandler(product)"
                                :data-toggle="isAllowToShowDetailModal(product)" data-target="#detailModal">
                                <div v-if="product.remoteImagePath === null || product.remoteImagePath === undefined"
                                    class="square-box shadow-menu" :style="{
                                        'background-color': getImgColor(product.indexColor), width: '100%',
                                    }">
                                    <span class="font-weight-bold badge add-to-cart-badges"></span>
                                    <span v-if="getTotalQuantity(product.ProductPLU[0].id) == 0"
                                        class="font-weight-bold bg-color-theme badge add-to-cart-badges-noqty">+</span>
                                    <span v-else class="font-weight-bold badge add-to-cart-badges">
                                        {{ getTotalQuantity(product.ProductPLU[0].id) }}
                                    </span>
                                </div>
                                <div v-else
                                    v-lazy:background-image="getImageURL(product.remoteImagePath, '300')"
                                    class="square-box shadow-menu" :style="{
                                        width: '100%', 'background-size': 'cover', 'background-position': 'center center',
                                    }">
                                    <div v-if="product.skuType !== 'P'">
                                        <span v-if="getTotalQuantity(product.ProductPLU[0].id) == 0"
                                            class="font-weight-bold bg-color-theme badge add-to-cart-badges-noqty">+</span>
                                        <span v-else class="font-weight-bold badge add-to-cart-badges">
                                            {{ getTotalQuantity(product.ProductPLU[0].id) }}
                                        </span>
                                    </div>
                                    <div v-else>
                                        <span
                                            v-if="getTotalQuantity(product.ProductPLU[0].id) == 0 && isAllowToOrder(product)"
                                            class="font-weight-bold bg-color-theme badge add-to-cart-badges-noqty">+</span>
                                        <span v-else-if="!isAllowToOrder(product)"
                                            class="font-weight-bold add-to-cart-badges-nostock">
                                            <h4 class="mt-2 text-center">{{ $t('outOfStock') }}</h4>
                                        </span>
                                        <span v-else class="font-weight-bold badge add-to-cart-badges">
                                            {{ getTotalQuantity(product.ProductPLU[0].id) }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="mt-2 h5 autoShowHide" style="padding-top: 5px;">
                                    {{ getProductName(product) }}
                                </div>
                                <span>
                                    <span hidden>
                                        {{ (qshow = getTotalQuantity(product.ProductPLU[0].id)) }}
                                    </span>
                                    <span v-if="qshow > 0" class="mt-2 font-weight-bold badge badge-success"></span>
                                </span>
                            </div>
                            <div class="d-flex justify-content-between">
                                <h6 class="text-grey pl-1 pb-3">
                                    ฿{{ product.ProductPRU[0]?.exceedUc || '' }}
                                </h6>
                            </div>
                        </div>
                    </div>
                    <!-- Load More (normal view) -->
                    <div v-if="currentPage < pageCount" class="text-center p-3">
                        <button class="btn btn-outline-secondary btn-sm load-more-btn" :disabled="loadingMore"
                            @click="loadMoreProducts()">
                            <span v-if="loadingMore">กำลังโหลด...</span>
                            <span v-else>โหลดเพิ่มเติม ({{ currentPage }}/{{ pageCount }})</span>
                        </button>
                    </div>
                    <div v-if="isSelfOrderEnabled !== true" class="row p-2">
                        <div v-if="display === 'list'" class="col p-0" style="opacity: 0.5">
                            <table class="mb-3" aria-describedby="" style="width: 100%">
                                <tr v-for="(product, index) in products" :key="product.objectId + '-' + index"
                                    style="border-bottom: 1px solid rgba(246, 246, 246)">
                                    <td style="width: 25%; padding: 7px">
                                        <div v-if="product.remoteImagePath === null || product.remoteImagePath === undefined"
                                            class="square-box shadow-menu" :style="{
                                                'background-color': getImgColor(product.indexColor), width: '100%',
                                            }"></div>
                                        <div v-else class="square-box shadow-menu" :style="{
                                            'background-image': `url('${getImageURL(product.remoteImagePath, '100')}')`,
                                            'background-size': 'cover', width: '100%',
                                        }"></div>
                                    </td>
                                    <td valign="top" class="p-2">
                                        <div class="d-flex justify-content-between">
                                            <div class="h6 text-grey autoShowHide">{{ getProductName(product) }}</div>
                                        </div>
                                        <div class="d-flex justify-content-between">
                                            <h6 class="text-black">
                                                <strong>฿{{ product.ProductPRU[0]?.exceedUc || '' }}</strong>
                                            </h6>
                                            <small>{{ product.unit.name }}</small>
                                        </div>
                                    </td>
                                </tr>
                            </table>
                        </div>
                        <div class="col-6 pr-2 pl-2" v-else-if="display === 'grid'"
                            v-for="(product, index) in products" :key="product.objectId + '-grid-' + index"
                            style="opacity: 0.5">
                            <div v-if="product.remoteImagePath === null || product.remoteImagePath === undefined"
                                class="square-box shadow-menu" :style="{
                                    'background-color': getImgColor(product.indexColor), width: '100%',
                                }"></div>
                            <div v-else class="square-box shadow-menu" :style="{
                                'background-image': `url('${product.remoteImagePath}')`,
                                'background-size': 'cover', width: '100%',
                            }"></div>
                            <div class="d-flex justify-content-between">
                                <div class="mt-2 h6 text-grey autoShowHide">{{ getProductName(product) }}</div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <h6 class="text-black pb-3">
                                    <strong>฿{{ product.ProductPRU[0]?.exceedUc || '' }}</strong>
                                </h6>
                                <small>{{ product.unit.name }}</small>
                            </div>
                        </div>
                    </div>
                </template>
            </div>
        </div>
        <div class="modal fade" id="detailModal" style="z-index: 9999;" data-backdrop="false">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-body">
                        <div style="z-index: 1080;" class="close " data-dismiss="modal">
                            <div class="d-flex justify-content-end "> <img width="10%" src="/img/close.png">
                            </div>
                        </div>
                        <detail v-bind:cartTotal="cartTotal" v-bind:SKUObjectId="SKUObjectId"
                            @update-cartTotal="updateCartTotal">
                        </detail>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import poscrm from '@/services/poscrm'
import util from '@/util/util'
import '@/util/menu.css'
import Detail from './AppProductDetails'

export default {
    props: ['categoryObjectId', 'searchVal', 'display', 'categories'],
    components: {
        Detail,
    },
    data() {
        return {
            products: [],
            categoryName: '',
            SKUObjectId: '',
            cartTotal: 0,
            orderCompleted: Boolean,
            currentPage: 1,
            pageCount: 1,
            loadingMore: false,
            scrollSpyObserver: null,
        }
    },
    computed: {
        ...mapGetters(['shopLineOA']),
        isAllCategory() {
            return !this.categoryObjectId || this.categoryObjectId === '';
        },
        isFullyLoaded() {
            return this.currentPage >= this.pageCount;
        },
        groupedProducts() {
            if (!this.isAllCategory || this.products.length === 0) {
                return [];
            }
            // Build maps from categories prop (if available) for sequence & icon
            const categorySeqMap = {};
            const categoryIconMap = {};
            const categoryNameMap = {};
            const categoryTranslationMap = {};
            if (this.categories && this.categories.length > 0) {
                this.categories.forEach(cat => {
                    categorySeqMap[cat.objectId] = cat.sequence || 999;
                    categoryIconMap[cat.objectId] = cat.indexIcon || '';
                    categoryNameMap[cat.objectId] = cat.name || '';
                    categoryTranslationMap[cat.objectId] = cat.nameTranslation || null;
                });
            }
            const getCatName = (catId, fallbackName) => {
                const locale = this.$i18n.locale;
                const translation = categoryTranslationMap[catId];
                if (translation && translation[locale]) {
                    return translation[locale];
                }
                try {
                    const config = JSON.parse(localStorage.getItem('languageConfig'))
                    if (config && config.fallbackType === 'translation' && config.fallbackLanguage) {
                        if (translation && translation[config.fallbackLanguage]) {
                            return translation[config.fallbackLanguage];
                        }
                    }
                } catch (e) {
                    // ignore
                }
                return fallbackName || 'อื่นๆ';
            };

            const groups = [];
            this.products.forEach(product => {
                const catId = product.category?.objectId || product.categoryObjectId || 'uncategorized';
                const catName = getCatName(catId, product.category?.name || categoryNameMap[catId]);
                const catSeq = categorySeqMap[catId] || 999;
                const catIcon = categoryIconMap[catId] || '';
                let group = groups.find(g => g.categoryObjectId === catId);
                if (!group) {
                    group = { categoryObjectId: catId, categoryName: catName, sequence: catSeq, indexIcon: catIcon, products: [] };
                    groups.push(group);
                }
                group.products.push(product);
            });
            // Sort by category sequence only when fully loaded;
            // otherwise keep first-appearance order (as API returned)
            if (this.isFullyLoaded) {
                groups.sort((a, b) => a.sequence - b.sequence);
            }
            return groups;
        },
        uid() {
            return `${localStorage.getItem('uid')}`
        },
        shopObjectId() {
            return `${localStorage.getItem('shopObjectId')}`
        },
        isSelfOrderEnabled() {
            // let enabled = this.shop?.delivery?.isSelfOrderEnabled
            // if (enabled !== true) {
            //     sessionStorage.clear()
            //     localStorage.clear()
            //     window.location.href = '/texp?errorCode=-4001'
            // }
            // เนื่องจาก this.shop โหลดไม่ทัน ก่อนเช็คเงื่อนไข isSelfOrderEnabled ทำให้ this.shop?.delivery?.isSelfOrderEnabled == undefined
            // ส่งผลให้เกิด Error 4001
            return true
        },
        shop() {
            return this.shopLineOA.find(
                (detail) => detail.objectId === this.shopObjectId
            )
        },
        noImg() {
            return process.env.VUE_APP_NOIMAGE
        },
    },
    mounted() {
        $('#detailModal').on('shown.bs.modal', () => {
            document.body.style.overflow = 'hidden';
            const position = sessionStorage.getItem('scrollPosition');
            window.scrollTo(0, -1);
            setTimeout(() => {
                window.scrollTo(0, position);
            }, 500);
        })
        $('#detailModal').on('hidden.bs.modal', () => {
            const postion = sessionStorage.getItem('scrollPosition')
            window.scrollTo(0, postion)
            document.body.style.overflow = ''
        })
    },
    beforeDestroy() {
        $('#detailModal').off('shown.bs.modal');
        $('#detailModal').off('hidden.bs.modal');
        document.body.style.overflow = ''
        if (this.scrollSpyObserver) {
            this.scrollSpyObserver.disconnect();
        }
    },
    created() {
        this.getProduct()
        this.cartLists = JSON.parse(sessionStorage.getItem('cart')) || []
        this.getReceiptTransaction()
    },
    methods: {
        ...util,
        getProductName(product) {
            const locale = this.$i18n.locale
            const translation = product.nameTranslation || product.ProductPLU?.[0]?.nameTranslation
            if (translation && translation[locale]) {
                return translation[locale]
            }
            try {
                const config = JSON.parse(localStorage.getItem('languageConfig'))
                if (config && config.fallbackType === 'translation' && config.fallbackLanguage) {
                    if (translation && translation[config.fallbackLanguage]) {
                        return translation[config.fallbackLanguage]
                    }
                }
            } catch (e) {
                // ignore
            }
            return product.SKUName
        },
        setupScrollSpy() {
            this.$nextTick(() => {
                if (!this.isFullyLoaded || !this.isAllCategory) return;
                const sections = this.$el.querySelectorAll('.category-section');
                if (sections.length === 0) return;

                let isReady = false;
                setTimeout(() => { isReady = true; }, 500);

                this.scrollSpyObserver = new IntersectionObserver((entries) => {
                    if (!isReady) return;
                    const intersecting = entries.filter(e => e.isIntersecting);
                    if (intersecting.length > 0) {
                        const topEntry = intersecting.reduce((a, b) =>
                            a.boundingClientRect.top < b.boundingClientRect.top ? a : b
                        );
                        const sectionId = topEntry.target.id;
                        const categoryObjectId = sectionId.replace('category-section-', '');
                        if (this._lastEmittedCategory === categoryObjectId) return;
                        this._lastEmittedCategory = categoryObjectId;
                        this.$emit('category-in-view', categoryObjectId);
                    }
                }, {
                    root: null,
                    rootMargin: '-10% 0px -70% 0px',
                    threshold: 0
                });

                sections.forEach(section => {
                    this.scrollSpyObserver.observe(section);
                });
            });
        },
        trackButtonClick(buttonLabel) {
            if (typeof window.gtag === 'function') {
                window.gtag('event', 'click', {
                    event_label: buttonLabel,
                });
            } else {
                console.error('gtag is not defined.');
            }
        },
        getTotalQuantity(productId) {
            const cart = JSON.parse(sessionStorage.getItem('cart')) || {}
            let result = 0
            if (cart.length > 0) {
                result = cart
                    .filter(product => product.productPLU.id === productId)
                    .reduce((total, product) => {
                        const quantity = typeof product.quantity === 'number' ? product.quantity : 0;
                        return total + quantity;
                    }, 0);
            }
            return result
        },
        isAllowToShowDetailModal(product) {
            if (product.skuType !== 'P') {
                return 'modal';
            }
            else if (product.skuType == 'P' && this.isAllowToOrder(product) == true) {
                return 'modal';
            }
        },
        productDetailHandler(product) {
            this.trackButtonClick('menulist/ProductDetail(Normal Menu)');
            this.SKUObjectId = product.objectId
            sessionStorage.setItem('scrollPosition', window.scrollY)
        },
        isAllowToOrder(product) {
            if (product.ProductSKUStock.onhandQty > product.ProductSKUStock.notAllowMinQty) {
                return true
            }
            else if (product.ProductSKUStock.notAllowMinQty == null) {
                return true
            }
            else {
                return false
            }
        },
        setErrorImg(event, image) {
            event.target.src = this.noImg;
        },
        quantityShow(productPLUId) {
            let quantity = 0;
            for (let item in productPLUId) {
                const locationInCart = this.cartLists.findIndex((p) => {
                    return p.productPLUId === productPLUId[item].id;
                });
                if (locationInCart !== -1) {
                    quantity += this.cartLists
                        .filter((i) => i.productPLUId === productPLUId[item].id)
                        .reduce((a, b) => a + b.quantity, 0);
                }
            }
            return quantity;
        },
        updateCartTotal(total) {
            this.cartTotal = total;
            this.$emit('update-cartTotal', total);
            this.$forceUpdate();
        },
        getImgColor(indexColor) {
            return util.generateColor(indexColor);
        },
        async getProduct(page = 1) {
            const uid = this.uid;
            const categoryObjectId = this.categoryObjectId;

            let params = {
                shopObjectId: this.shopObjectId,
                page: page,
                limit: 300,
                searchVal: this.searchVal,
            };
            if (categoryObjectId && categoryObjectId !== '') {
                params['categoryObjectId'] = categoryObjectId;
            }

            try {
                const res = await poscrm({
                    method: 'get',
                    url: '/api/v1.1/' + uid + '/Shop/getproduct/menu',
                    params: params,
                });
                const response = res?.data?.data || [];
                const paginate = res?.data?.paginate || {};

                if (page === 1) {
                    this.products = response;
                } else {
                    this.products = [...this.products, ...response];
                }

                this.currentPage = paginate.currentPage || page;
                this.pageCount = paginate.pageCount || 1;
            } catch (error) {
                throw new Error(error);
            }
        },
        async loadMoreProducts() {
            if (this.currentPage >= this.pageCount || this.loadingMore) return;
            this.loadingMore = true;
            try {
                await this.getProduct(this.currentPage + 1);
            } finally {
                this.loadingMore = false;
            }
        },
        async getReceiptTransaction() {
            let receiptObjectId = localStorage.getItem('receiptObjectId') || null;

            if (receiptObjectId != null) {
                try {
                    await poscrm
                        .get('/api/v1.1/' + this.uid + '/Receipt/data/' + receiptObjectId)
                        .then((res) => {
                            if (res.data?.data?.document != null) {
                                let document = {}
                                document = res.data.data.document;
                                if (document.receiptStatus === 'A' || document.receiptStatus === 'T') {
                                    this.orderCompleted = true;
                                    localStorage.clear();
                                    sessionStorage.clear();
                                } else {
                                    const table = document.table || [];
                                    const paymentStatus = table.tableStatus || '';

                                    if (paymentStatus == 'P') {
                                        // this.$router.push('/dine-in/pending/payment');
                                    }
                                }
                            } else {
                                localStorage.clear();
                                sessionStorage.clear();
                                this.$router.push('/texp?errorCode=-4002');
                            }
                        });
                } catch (error) {
                    throw new Error(error);
                }
            } else {
                let uid = localStorage.getItem('uid');
                if (uid == null) {
                    this.orderCompleted = true;
                }
            }
        },
    },
    watch: {
        categoryObjectId() {
            this.currentPage = 1;
            this.pageCount = 1;
            this.getProduct()
        },
        products() {
            this.$nextTick(() => {
                if (this.scrollSpyObserver) {
                    this.scrollSpyObserver.disconnect();
                }
                this.setupScrollSpy();
            });
        },
        searchVal(newVal, oldVal) {
            this.searchVal = newVal;
            this.currentPage = 1;
            this.pageCount = 1;
            this.getProduct()
        },
    },
}
</script>

<style scoped>
.modal-body {
    padding: 0rem;
}

.limited-text-two {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    max-width: 100%;
    word-wrap: break-word;
}

.category-group-header {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 10px 8px 4px;
    margin-top: 4px;
}

.category-group-name {
    font-size: 16px;
    font-weight: bold;
    color: var(--theme-color, #2d8a6e);
}

.category-group-icon {
    font-size: 15px;
    color: var(--theme-color, #2d8a6e);
}

.load-more-btn {
    border-radius: 20px;
    padding: 8px 24px;
    font-size: 14px;
}

.load-more-btn:disabled {
    opacity: 0.6;
}
</style>
